import React from 'react'
import ReactDOM from 'react-dom/client'
import AppWithTheme from './AppWithTheme.tsx'
import './index.css'
import './assets/fonts/fonts.css'
import axios from 'axios'

// ✅ Configuración de Axios
axios.defaults.baseURL = import.meta.env.VITE_API_URL || 'https://app.ingeai7.com/api'
axios.defaults.withCredentials = true

// REQUEST INTERCEPTOR
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') // ✅ Usar 'token' no 'accessToken'
    
    if (token && token !== 'null' && token !== 'undefined') {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
  },
  (error) => Promise.reject(error)
)

// RESPONSE INTERCEPTOR (manejo de sesión)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    
    // Si el token expiró, intentar refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      
      const sessionId = localStorage.getItem('sessionId')
      const refreshToken = localStorage.getItem('refreshToken')
      
      if (sessionId && refreshToken) {
        try {
          const { data } = await axios.post('/auth/refresh', {
            sessionId,
            refreshToken
          })
          
          // ✅ Actualizar token en localStorage
          localStorage.setItem('token', data.accessToken)
          originalRequest.headers.Authorization = `Bearer ${data.accessToken}`
          
          return axios(originalRequest)
        } catch (refreshError) {
          // Refresh falló, cerrar sesión
          localStorage.clear()
          window.location.href = '/login'
          return Promise.reject(refreshError)
        }
      }
      
      // Sin refresh token, cerrar sesión
      const isAuthEndpoint = originalRequest.url?.includes('/auth/login')
      if (!isAuthEndpoint) {
        localStorage.clear()
        window.location.href = '/login'
      }
    }
    
    return Promise.reject(error)
  }
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWithTheme />
  </React.StrictMode>
)